export default __webpack_public_path__ + "static/media/080_finish_good.vp9.d01b47d6.webm";